export enum ContractType {
    CDI = 'CDI',
    CDD = 'CDD'
}

declare type Contract = {
    id: number
    employeeId: number
    contratType: ContractType
    startDate: Date
    endDate?: Date | null
    createdAt: Date
    hoursPerMonth: number
    hourlyRate: number
}

export default Contract;
